import { Box, FormGroup, styled } from '@mui/material';

export const StyledBlock = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 0),
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const StyledBlockRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(1.5)
}));

export const StyledTimeFields = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  width: 220
}));

export const StyledDescriptionField = styled(Box)({
  flex: 1,
  minWidth: 120
});

export const StyledDayTypes = styled(FormGroup)(({ theme }) => ({
  columnGap: theme.spacing(2)
}));
